import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl, getAuthHeaders } from '../../../../config/api.config';
import './OwnerDashboard.css';
import { Link } from 'react-router-dom';

const OwnerDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({
    totalSchools: 0,
    totalAdmins: 0,
    totalTeachers: 0,
    totalStudents: 0
  });

  // Fetch all schools
  useEffect(() => {
    const fetchSchools = async () => {
      try {
        setLoading(true);
        // Use the stats endpoint as per documentation
        const response = await axios.get(
          getApiUrl('/api/v1/stem@home/owner/stats'),
          { headers: getAuthHeaders() }
        );

        if (response.data.success) {
          // Process the response according to the actual API structure
          const { schools, users } = response.data.data || {};
          
          setStats({
            totalSchools: schools?.total || 0,
            totalAdmins: users?.byRole?.admin || 0,
            totalTeachers: users?.byRole?.teacher || 0,
            totalStudents: users?.byRole?.student || 0
          });
        } else {
          setError(response.data.message || 'Failed to load statistics');
        }
      } catch (err) {
        console.error('Error fetching statistics:', err);
        setError(err.response?.data?.message || 'Failed to load statistics');
      } finally {
        setLoading(false);
      }
    };

    fetchSchools();
  }, []);

  if (loading) {
    return (
      <div className="owner-dashboard-container">
        <div className="loading">Loading data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="owner-dashboard-container">
        <div className="error">{error}</div>
      </div>
    );
  }

  return (
    <div className="owner-dashboard-container">
      <div className="dashboard-header">
        <div className="dashboard-info">
          <h1>Owner Dashboard</h1>
        </div>
      </div>

      <div className="stats-container">
        <Link to="/school-management" className="stat-card-link">
          <div className="stat-card">
            <h3>Schools</h3>
            <p className="stat-number">{stats.totalSchools}</p>
          </div>
        </Link>
        <Link to="/user-management?role=admin" className="stat-card-link">
          <div className="stat-card">
            <h3>Admins</h3>
            <p className="stat-number">{stats.totalAdmins}</p>
          </div>
        </Link>
        <Link to="/user-management?role=teacher" className="stat-card-link">
          <div className="stat-card">
            <h3>Teachers</h3>
            <p className="stat-number">{stats.totalTeachers}</p>
          </div>
        </Link>
        <Link to="/user-management?role=student" className="stat-card-link">
          <div className="stat-card">
            <h3>Students</h3>
            <p className="stat-number">{stats.totalStudents}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default OwnerDashboard; 